import bazaarColorOrderingCz from './bazaar-color-ordering-cz.json';
import bazaarColorOrderingSk from './bazaar-color-ordering-sk.json';

export const colorOrderingCz = bazaarColorOrderingCz.data.colorOrderingCz;
export const colorOrderingSk = bazaarColorOrderingSk.data.colorOrderingSk;
